import {Component, Input, OnInit} from '@angular/core';
import {FeaturedProductIconConfig} from '../../../models/featured-product';
import {FeaturedProductsService} from '../../../services/featured-products.service';

@Component({
  selector: 'app-featured-product-icon',
  templateUrl: './featured-product-icon.component.html'
})
export class FeaturedProductIconComponent implements OnInit {

  @Input() config: FeaturedProductIconConfig;
  url: string;

  constructor(private featuredProductsService: FeaturedProductsService) { }

  ngOnInit(): void {
    this.url = this.featuredProductsService.getIconUrlWithParams(this.config.key);
  }

}
